if (!window.__formInputKlaviyoNewsletterLoaded) {
  window.__formInputKlaviyoNewsletterLoaded = true;

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const klaviyoApiRevision = "2026-04-15";

  const attachFormHook = (form) => {
    if (form.dataset.klaviyoHookAttached === "true") return;

    const emailField = form.querySelector('[data-klaviyo-email]');
    if (!emailField) return;

    form.dataset.klaviyoHookAttached = "true";

    form.addEventListener("submit", () => {
      const klaviyoKey = (form.getAttribute("data-klaviyo-key") || "").trim();
      const klaviyoListId = (form.getAttribute("data-klaviyo-list-id") || "").trim();
      const email = (emailField.value || "").trim();
      const source = (form.getAttribute("data-klaviyo-source") || "Shopify Theme").trim();

      if (!klaviyoKey || !klaviyoListId || !email || !emailRegex.test(email)) return;

      fetch(
        `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(klaviyoKey)}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json", revision: klaviyoApiRevision },
          body: JSON.stringify({
            data: {
              type: "subscription",
              attributes: {
                custom_source: source,
                profile: { data: { type: "profile", attributes: { email } } }
              },
              relationships: { list: { data: { type: "list", id: klaviyoListId } } }
            }
          }),
          keepalive: true
        }
      ).catch(() => {});
    });
  };

  const bindForms = () => {
    document.querySelectorAll("form[data-klaviyo-form]").forEach(attachFormHook);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bindForms, { once: true });
  } else {
    bindForms();
  }
}
